import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import '../../styles/graphics.scss';

function RatingEvolutionGraph({ type, data, annotations }: any) {

    const options: ApexOptions = {
        chart: {
            type: type,
            zoom: { enabled: false },
            toolbar: { show: false },
            animations: { enabled: false }
        },
        colors: ["#008FFB"],
        annotations: { xaxis: annotations ?? [] },
        xaxis: {
            type: type === 'line' ? "category" : "numeric",
            labels: { format: "yyyy-MMM-dd" },
            axisBorder: { show: false }, // Remove axis border
            axisTicks: { show: false }
        },
        yaxis: {
            min: 1,
            max: 5,
            tickAmount: 4,
            labels: {
                formatter: (value) => value.toFixed(2), // Round to 0 decimal places
            },
            axisBorder: { show: false }, // Remove axis border
            axisTicks: { show: false },
        },
        stroke: { curve: 'smooth', width: 3 },
        tooltip: { x: { format: type === 'line' ? "datetime" : "string" } },
        dataLabels: {
            enabled: true,
            formatter: (val: number) => val.toFixed(2),
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "90%",
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'center'
                }
            }
        },
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 3
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={data.series}
                type={type}
                height={300}
                width="95%"
            />
        </div >
    );
}

export default RatingEvolutionGraph;